import { conventions } from './conventions'
import { currencyConventions } from './currencyConventions'

function mergePrecision(base = {}, override = {}) {
  const keys = new Set([...Object.keys(base), ...Object.keys(override)])
  const out = {}
  for (const key of keys) {
    out[key] = { ...(base[key] ?? {}), ...(override[key] ?? {}) }
  }
  return out
}

export function resolveConventions({ brand, currency }) {
  const brandConfig = conventions[brand] ?? {}

  // 1) number config: strip `currencies` out cleanly, then default <- brand
  const { currencies: brandCurrencies = {}, ...brandNumber } = brandConfig
  const number = { ...conventions.DEFAULT, ...brandNumber }

  // 2) global currency precision (or DEFAULT)
  const baseCurrency = currencyConventions[currency] ?? currencyConventions.DEFAULT ?? {}

  // 3) brand's per-currency override (may be partial)
  const brandCurrencyOverride = brandCurrencies[currency] ?? {}

  // 4) deep-merge so partial overrides don't wipe inherited min/max
  const currencyConfig = mergePrecision(baseCurrency, brandCurrencyOverride)

  return { brand, currency, number, currencyConfig }
}
